import importer from 'common/importer'
/* ALERT */
const alert = importer('Helpers/Alert')
export default function * success ({ res }) {
  // console.log(res)
  // yield alert(
  //   'Success!',
  //   'Your password has been successfully changed'
  // )
}
